import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/down.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4a888388"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top",
  id: "content"
};
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_title"
  }, [/*#__PURE__*/_createTextVNode(" 百城愿景 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 成为一流的儿童健康阅读服务商 ")], -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_abs"
  }, " BECOME A FIRST-CLASS CHILDREN'S READING HEALTH SERVICE PROVIDER.I HOPE EVERY CHILD WILL LOVE READING ", -1);
});

var _hoisted_5 = {
  class: "block"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, "JOB RECRUITMENT", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title2"
  }, "岗位招聘", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_border"
  }, null, -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_abs"
  }, " 简历投递、更多岗位咨询，请发送邮件至：bc@bcepd.cn ", -1);
});

var _hoisted_10 = {
  class: "block_detail"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail_name"
  }, "行政专员", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "down"
  }, null, -1);
});

var _hoisted_13 = [_hoisted_11, _hoisted_12];
var _hoisted_14 = {
  key: 0,
  class: "detail_content"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_name"
  }, "岗位相关技能", -1);
});

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_detail"
  }, [/*#__PURE__*/_createTextVNode(" 专业不限，最好有过行政相关工作经验； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 熟悉各类办公软件操作，熟悉商务礼仪者优先； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 为人踏实、有耐心、责任心强、对工作有热情； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 熟悉公关礼仪等相关业务知识； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 熟练使用操作办公自动化设备； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 具有较强的文字策划能力强； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 具有良好地沟通能力，有团队协作精神，与人相处融洽。 ")], -1);
});

var _hoisted_17 = [_hoisted_15, _hoisted_16];
var _hoisted_18 = {
  class: "block_detail"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail_name"
  }, "销售专员", -1);
});

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "down"
  }, null, -1);
});

var _hoisted_21 = [_hoisted_19, _hoisted_20];
var _hoisted_22 = {
  key: 0,
  class: "detail_content"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_name"
  }, "岗位相关技能", -1);
});

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_detail"
  }, [/*#__PURE__*/_createTextVNode(" 市场营销或相关专业大专以上学历； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 有市场营销、产品知识等方面的知识和销售经验； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 熟悉市场营销工作；熟悉零售运作模式； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 有地区销售网络和销售关系； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 坦诚自信，乐观进取，高度的工作热情； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 有良好的团队合作精神，有敬业精神； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 具有独立的分析和解决问题的能力； "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 良好的沟通技巧和说服能力，能承受较大的工作压力。 ")], -1);
});

var _hoisted_25 = [_hoisted_23, _hoisted_24];
var _hoisted_26 = {
  class: "block_detail"
};

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail_name"
  }, "网站文案编辑", -1);
});

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "down"
  }, null, -1);
});

var _hoisted_29 = [_hoisted_27, _hoisted_28];
var _hoisted_30 = {
  key: 0,
  class: "detail_content"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_name"
  }, "岗位相关技能", -1);
});

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_detail"
  }, [/*#__PURE__*/_createTextVNode(" 能独立操作实验室可用性测试、用户需求调研等工作 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 具备统计和数据分析能力，善于沟通和报告撰写 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 能接受挑战，并能同时应对多个项目 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 良好的口头表达能力 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 优秀的组织管理能力，执行力和跨团队协作能力 ")], -1);
});

var _hoisted_33 = [_hoisted_31, _hoisted_32];
var _hoisted_34 = {
  class: "block_detail"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail_name"
  }, "项目经理", -1);
});

var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "down"
  }, null, -1);
});

var _hoisted_37 = [_hoisted_35, _hoisted_36];
var _hoisted_38 = {
  key: 0,
  class: "detail_content"
};

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_name"
  }, "岗位相关技能", -1);
});

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "skill_detail"
  }, [/*#__PURE__*/_createTextVNode(" 通web标准的网站构建，有成功案例 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 精通图像处理软件与网页编辑软件 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 对业界最新的页面实现有浓厚的兴趣和深入的见解 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 逻辑分析能力强，善于沟通，较强的学习能力 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 熟悉HTML5和CSS3的优先考虑 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 熟悉对象模型与脚本语言，有前台开发经验者优先考虑 ")], -1);
});

var _hoisted_41 = [_hoisted_39, _hoisted_40];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    interval: 5000,
    loop: "true"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: item
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.url,
              class: "banner"
            }, null, 8, _hoisted_2), _hoisted_3, _hoisted_4];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "detail_block",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleDown1 && _ctx.handleDown1.apply(_ctx, arguments);
    })
  }, _hoisted_13), _ctx.down1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: "detail_block",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleDown2 && _ctx.handleDown2.apply(_ctx, arguments);
    })
  }, _hoisted_21), _ctx.down2 ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
    class: "detail_block",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleDown3 && _ctx.handleDown3.apply(_ctx, arguments);
    })
  }, _hoisted_29), _ctx.down3 ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", {
    class: "detail_block",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.handleDown4 && _ctx.handleDown4.apply(_ctx, arguments);
    })
  }, _hoisted_37), _ctx.down4 ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41)) : _createCommentVNode("", true)])])], 64);
}